import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import Logout from '@mui/icons-material/Logout';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {deleteLocalStorage, getLocalStorage, setLocalStorage} from "../../util/storage";
import {clearRegistrationAttribution, setSharedLoginState} from "../../util/registrationAttribution";
import {LoginProps} from "../../types/authority";
import {useLocation, useNavigate} from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import LanguageIcon from '@mui/icons-material/Language';
import './style.css'
import i18n from "i18next";
import {Editor} from "tldraw";
import Payment from "../payment";
import {useCallback, useEffect, useMemo, useState} from "react";
import PersonIcon from '@mui/icons-material/Person';
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, RootState} from "../../store";
import droplet from "../../assets/droplet.png";
import {
    GiftBlackIcon,
    GiftIcon,
    LanguageNewIcon,
    LeaveIcon,
    LockIcon, MobileDropIcon, MobileHomeIcon, MobileNotifyIcon, MobileShareIcon, Notify,
    ShapeIcon,
    ShareCopy,
    ShareIcon,
    ThemeModeIcon
} from "../../icons";
import {useThemeMode} from "@naro/krene-theme";
import HttpsIcon from '@mui/icons-material/Https';
import HomeIcon from '@mui/icons-material/Home';
import {createBoardListShare, deleteShareId, getBoardListShare} from "../../api/authority";
import {getPendingTasks} from "../../api/task";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";
import Invitation from "../invitation";
import WaterDropBag from "../payment/waterDropBag";
import {
    fetchMemberInfoAsync,
    fetchNotifyUnreadCountAsync, setDropActiveDialogOpen,
    setNotifyDialogTipsChange,
    setOpenDropDialogChange,
    setOpenMembershipPurchaseDialogChange,
    setOpenYearMemberDialogChange,
    setPendingTasks
} from "../../store/memberSlice";
import DropActive from "../invitation/dropActive";
import NewUserCountdown from "./NewUserCountdown";
import {usePendingTaskPoller} from "../../hooks/usePendingTask";
import AnimatedNumber from "../../util/AnimatedNumber";
import {coverSelectCanvasImage, setCurrentDialogImageInfo, setGlobalMessage} from "../../store/taskSlice";
import {setCurrentImageShape, setCurrentStepId} from "../../store/drawSlice";
import {caseBoardInfoProps} from "../../types/board.types";

// 主题切换入口开关：暗色模式与子应用(微前端)主题化未完成前先隐藏，Phase 3 完成后置为 true
const SHOW_THEME_SWITCH = true;

export default function Profile(props:{editor?: Editor, boardInfo?: caseBoardInfoProps | null}) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [shareAnchorEl, setShareAnchorEl] = React.useState<null | HTMLElement>(null);
    const [collaboratorAnchorEl, setCollaboratorAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const shareOpen = Boolean(shareAnchorEl);
    const collaboratorOpen = Boolean(collaboratorAnchorEl);
    const navigate = useNavigate();
    const {editor, boardInfo} =  props
    const [labelDialogOpen, setLabelDialogOpen] = useState(false)

    const [invitationDialogOpen, setInvitationDialogOpen] = useState(false)

    const dropActiveDialogOpen =  useSelector((state: RootState) => state.member.dropActiveDialogOpen);
    const reduxUserInfo = useSelector((state: RootState) => state.user.userInfo);

    const {
        trackBillingPopupShow,
        trackShareClick,
        trackInvitePopupClick,
        trackActivityPopupClick,
        trackNotificationInboxClick,
        trackThemeModeSelect
    } = useMatomoTrackingPoint()

    const [shareId, setShareId] = useState<string>('')

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const openDropDialog = useSelector((state: RootState) => state.member.openDropDialog);
    const openMembershipPurchaseDialog = useSelector((state: RootState) => state.member.openMembershipPurchaseDialog);
    const openYearMemberDialog = useSelector((state: RootState) => state.member.openYearMemberDialog);
    const dispatch: AppDispatch = useDispatch();

    const { startPolling } = usePendingTaskPoller(() => {
        dispatch(fetchMemberInfoAsync());
    });


    useEffect(() => {
        if (openDropDialog) {
            setLabelDialogOpen(true)
        }
    }, [openDropDialog]);

    useEffect(() => {
        if (openMembershipPurchaseDialog) {
            setLabelDialogOpen(true);
            dispatch(setOpenDropDialogChange(false));
            dispatch(setOpenMembershipPurchaseDialogChange(false));
        }
    }, [openMembershipPurchaseDialog, dispatch]);

    useEffect(() => {
        if (openYearMemberDialog) {
            setLabelDialogOpen(true);
            dispatch(setOpenYearMemberDialogChange(false));
        }
    }, [openYearMemberDialog, dispatch]);


    const handleShareClose = () => {
        setShareAnchorEl(null);
    };

    const GuestMode = useSelector((state: RootState) => state.member.GuestMode);

    const onlyReady = useMemo(() => {
        return GuestMode === 'guest';
    }, [GuestMode]);

    const { t } = useTranslation()

    const memberInfo = useSelector((state: RootState) => state.member.memberInfo);
    const notifyUnreadCount = useSelector((state: RootState) => state.member.notifyUnreadCount);

    const [plans, setPlans] = useState([
        {
            plan: t('free_plan'),
            membershipTier: 'free',
            buttonColor: 'var(--c-border)',
        },
        {
            plan: t('plus_plan'),
            membershipTier: 'plus',
            buttonColor: 'var(--c-accent-light)',
        },
        {
            plan: t('pro_plan'),
            membershipTier: 'pro',
            buttonColor: 'var(--c-brand-light)',
        },
        {
            plan: t('max_plan'),
            membershipTier: 'max',
            buttonColor: 'linear-gradient(to right, var(--c-grad-start), var(--c-brand-light), var(--c-grad-end))',
        },
        {
            plan: t('plus_plan'),
            membershipTier: 'plus_year',
            buttonColor: 'var(--c-accent-light)',
        },
        {
            plan: t('pro_plan'),
            membershipTier: 'pro_year',
            buttonColor: 'var(--c-brand-light)',
        },
        {
            plan: t('max_plan'),
            membershipTier: 'max_year',
            buttonColor: 'linear-gradient(to right, var(--c-grad-start), var(--c-brand-light), var(--c-grad-end))',
        },
    ])

    const currentMember = useCallback(()=>{
        return plans.find(plan => plan.membershipTier === memberInfo?.membershipTier)
    }, [memberInfo, plans])

    const claimableActivitiesCount = useMemo(() => {
        if (!memberInfo?.activities?.length) return 0;
        const focusCount = memberInfo?.activities?.find(item => item.completionCondition === 'BACKGROUND_REVIEW' && item.status === 'pending' && !getLocalStorage('focus_active_red')) ? 1 : 0
        return memberInfo.activities.filter(item => item.status === 'claimable').length + focusCount;
    }, [memberInfo?.activities]);

    const loginOut = () => {
        deleteLocalStorage('userInfo')
        deleteLocalStorage('conversionId')
        clearRegistrationAttribution()
        setSharedLoginState(false)
        navigate('/dashboard/home', { replace: true })
        window.location.reload()
    }

    const changeLanguage = async (lng: string) => {
        let lang = lng
        await i18n.changeLanguage(lng);
        if (lng === 'zh') lang = 'zh-cn'
        editor && editor.user.updateUserPreferences({ locale: lang })
        handleClose(); // 切换语言后关闭菜单
    };

    const {mode, setMode} = useThemeMode();
    const changeThemeMode = (next: 'light' | 'dark' | 'system') => {
        trackThemeModeSelect({select_content: next, switch_from: mode, page_id: window.location.href})
        setMode(next)
        handleClose(); // 切换主题后关闭菜单
    };

    const useInfoStr = getLocalStorage('userInfo');
    const localUserInfo = useInfoStr ? JSON.parse(useInfoStr) as LoginProps : null;

    useEffect(() => {
        if (!localUserInfo) return;
        dispatch(fetchNotifyUnreadCountAsync());
        startPolling()
    }, []);

    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    const boardId = queryParams.get('boardId');

    const handleShareClick = (event: React.MouseEvent<HTMLElement>) => {
        trackShareClick({board_id: boardId})
        setShareAnchorEl(event.currentTarget);
    };

    const copyLink = async () => {
        let url = window.location.href;
/*        if (shareId) {
            const urlObj = new URL(url);
            urlObj.searchParams.set('shareId', shareId);
            url = urlObj.toString();
        }*/

        try {
            await navigator.clipboard.writeText(url);
            console.log('链接已复制到剪贴板');
        } catch (err) {
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'fixed';
            textArea.style.left = '-9999px';
            textArea.style.top = '-9999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                document.execCommand('copy');
                console.log('链接已复制到剪贴板');
            } catch (e) {
                console.error('复制失败:', e);
            }

            document.body.removeChild(textArea);
        }

        handleShareClose();
    };

    const [copyUuidTooltipOpen, setCopyUuidTooltipOpen] = useState(false);
    const [copyUuidTooltipText, setCopyUuidTooltipText] = useState('');
    const [copyUuidTooltipTimeout, setCopyUuidTooltipTimeout] = useState<NodeJS.Timeout | null>(null);

    const copyUuid = async () => {
        const uuid = localUserInfo?.uuid;
        if (!uuid) return;

        setCopyUuidTooltipOpen(false);

        try {
            await navigator.clipboard.writeText(uuid);
            setCopyUuidTooltipText('已复制');
            setCopyUuidTooltipOpen(true);
        } catch (err) {
            const textArea = document.createElement('textarea');
            textArea.value = uuid;
            textArea.style.position = 'fixed';
            textArea.style.left = '-9999px';
            textArea.style.top = '-9999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                document.execCommand('copy');
                setCopyUuidTooltipText('已复制');
            } catch (e) {
                console.error('复制失败:', e);
                setCopyUuidTooltipText('复制失败');
            }

            document.body.removeChild(textArea);
            setCopyUuidTooltipOpen(true);
        }

        if (copyUuidTooltipTimeout) clearTimeout(copyUuidTooltipTimeout);
        const timeout = setTimeout(() => setCopyUuidTooltipOpen(false), 2000);
        setCopyUuidTooltipTimeout(timeout);
    };

    useEffect(() => {
        getShareLIst()
    }, [boardId]);

    const getShareLIst = () => {
        if (boardId) {
            getBoardListShare(boardId).then(item => {
                if (item) {
                    const borderIdForDetail = item
                    if (borderIdForDetail.id) {
                        setShareId(borderIdForDetail.id)
                    }else {
                        setShareId('')
                    }
                }else {
                    setShareId('')
                }
            })
        }
    }

    const deleteBoardShare = () => {
        if (!shareId) return;
        deleteShareId(shareId).then(res => {
            getShareLIst()
        })
    }

    const createBoardShare = () => {
        if (!boardId || shareId) return
        createBoardListShare(boardId, '-1').then(res=> {
            getShareLIst()
        })
    }

    const trackPoint = (external: boolean) => {
        let billing_popup_from = ''

        if (external && boardId) billing_popup_from = 'board_userinfo'
        if (!external && boardId) billing_popup_from = 'board_userinfo_waterdrop'

        if (external && !boardId) billing_popup_from = 'homepage_userinfo'
        if (!external && !boardId) billing_popup_from = 'homepage_userinfo_waterdrop'

        trackBillingPopupShow({billing_popup_from: billing_popup_from, board_id: boardId})
    }

    useEffect(() => {
        if (dropActiveDialogOpen) setLocalStorage('focus_active_red', 1)
    }, [dropActiveDialogOpen]);

    return (
        <React.Fragment>
            <NewUserCountdown memberInfo={memberInfo} boardId={boardId} />
            <Payment labelDialogOpen={labelDialogOpen} handleSetLabelDialogClose={() => {
                setLabelDialogOpen(false)
            }}/>
            {
                localUserInfo && <Invitation labelDialogOpen={invitationDialogOpen} handleSetLabelDialogClose={() => {
                    setInvitationDialogOpen(false)
                }}/>
            }
            {
                localUserInfo && <DropActive labelDialogOpen={dropActiveDialogOpen} handleSetLabelDialogControl={()=>{
                    setInvitationDialogOpen(!invitationDialogOpen)
                }} handleSetDropActiveDialogControl={()=>{
                    dispatch(setDropActiveDialogOpen(!dropActiveDialogOpen))
                }} boardId={boardId} />
            }
            <div className='profile-container'>
                <div className='member-share pc-only' style={{display: onlyReady || !boardId ? 'none' : 'flex'}}
                     onClick={handleShareClick}><ShareIcon/>&nbsp;分享
                </div>
                <div className='giftButton pc-only btn-relative' style={{width: '106px'}} onClick={() => {
                    trackActivityPopupClick({page_id: window.location.href, switch_from: '首页'})
                    dispatch(setDropActiveDialogOpen(true))
                }}><GiftIcon/>&nbsp;免费领水滴
                    {claimableActivitiesCount > 0 && <div className='notify-badge'>{claimableActivitiesCount}</div>}
                </div>
                <div className='giftButton pc-only btn-relative'
                     onClick={() => {
                         trackNotificationInboxClick({ page_id: window.location.href })
                         dispatch(setNotifyDialogTipsChange(true))
                     }}><Notify/>&nbsp;消息中心
                    {notifyUnreadCount > 0 && <div className='notify-badge'>{notifyUnreadCount}</div>}
                </div>


                <div className='home-position mobile-only' style={{alignItems: 'center', justifyContent: 'center'}}>
                    {
                        boardId && <>
                            <div className='home-icon' onClick={() => {
                                dispatch(coverSelectCanvasImage(null))
                                dispatch(setCurrentDialogImageInfo(null))
                                dispatch(setCurrentImageShape(null))
                                dispatch(setGlobalMessage(''));
                                dispatch(setCurrentStepId(''));
                                if (reduxUserInfo) {
                                    navigate('/dashboard')
                                } else {
                                    navigate('/dashboard/home')
                                }
                            }}><MobileHomeIcon/></div>
                            <div className='board-name'>&nbsp;{boardInfo?.boardName}</div>
                        </>
                    }
                </div>

                {boardId &&
                    <div className="mobile-only mobile-tool-btn" onClick={handleShareClick}><MobileShareIcon/></div>}
                <div className="mobile-only mobile-tool-btn btn-relative" onClick={() => {
                    trackActivityPopupClick({page_id: window.location.href, switch_from: '首页'})
                    dispatch(setDropActiveDialogOpen(true))
                }}><MobileDropIcon/>
                    {claimableActivitiesCount > 0 && <div className='notify-badge'>{claimableActivitiesCount}</div>}
                </div>
                <div className="mobile-only mobile-tool-btn btn-relative" onClick={() => {
                    trackNotificationInboxClick({ page_id: window.location.href })
                    dispatch(setNotifyDialogTipsChange(true))
                }}><MobileNotifyIcon/>
                    {notifyUnreadCount > 0 && <div className='notify-badge'>{notifyUnreadCount}</div>}
                </div>

                {/*<div className='member-worker' style={{display: onlyReady || !boardId ? 'none' : 'flex'}}>
                    <div className='worker-total'>+3</div>
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ml: 2, marginLeft: '10px', position: 'relative'}}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar sx={{width: 30, height: 30}}>{localUserInfo?.email.slice(0, 1)}</Avatar>
                        <div style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '10px',
                            backgroundColor: 'var(--c-warning)',
                            position: "absolute",
                            right: "3px",
                            bottom: "4px"
                        }}></div>
                    </IconButton>
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ml: 2, marginLeft: '10px'}}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar sx={{width: 30, height: 30}}>{localUserInfo?.email.slice(0, 1)}</Avatar>
                    </IconButton>
                </div>
                <div className='dividing-line' style={{display: onlyReady || !boardId ? 'none' : 'block'}}></div>*/}
                <Menu
                    anchorEl={shareAnchorEl}
                    id="account-menu2"
                    open={shareOpen}
                    onClose={handleShareClose}
                    slotProps={{
                        paper: {
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px var(--c-shadow-mid))',
                                mt: 1.5,
                                '& .MuiAvatar-root': {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                },
                                '&::before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                    zIndex: 0,
                                },
                            },
                        },
                    }}
                    transformOrigin={{horizontal: 'right', vertical: 'top'}}
                    anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                >
                    <div className='share-title'>
                        <div className="share-title-text">分享绘板</div>
                        <div className='copyIcon' onClick={async () => {
                            await copyLink()
                        }}><ShareCopy/> &nbsp;复制链接
                        </div>
                    </div>
                    <div className="permission-label">浏览权限设置</div>

                    <MenuItem className="changeLang btn-relative">
                        <ListItemIcon>
                            {shareId ? <LanguageIcon fontSize='small'/> : <HttpsIcon fontSize='small'/>}
                        </ListItemIcon>
                        <span className="permission-text">
                         {shareId ? '拥有该链接的任何人可见' : '仅绘板所有者可见'}
                        </span>
                        <KeyboardArrowDownIcon sx={{position: 'absolute', right: 6}}/>
                        <div className="langBox">
                            <div className="flex-start-row"
                                 onClick={deleteBoardShare}>
                                <HttpsIcon fontSize='small'/>&nbsp;仅绘板所有者可见
                            </div>
                            <div className="flex-start-row"
                                 onClick={createBoardShare}>
                                <LanguageIcon fontSize='small'/>&nbsp;拥有该链接的任何人可见
                            </div>
                        </div>
                    </MenuItem>

                    {/*<Divider style={{
                        width: "96%",
                        marginLeft: "2%"
                    }}/>
                    <div
                        style={{color: 'var(--c-text-primary)', fontSize: '14px', fontWeight: 'bold', paddingLeft: "10px"}}>邀请协作者
                    </div>
                    <Box sx={{display: 'flex', gap: 1, alignItems: 'center', padding: '10px'}}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="请输入邮箱"
                            variant="outlined"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: 'var(--c-brand)',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: 'var(--c-brand)',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'var(--c-brand)',
                                    },
                                },
                            }}
                        />
                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                backgroundColor: 'var(--c-brand)',
                                '&:hover': {
                                    backgroundColor: '#6a4aaa',
                                }
                            }}
                        >
                            邀请
                        </Button>
                    </Box>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: 'var(--c-danger)',
                        padding: '6px',
                        backgroundColor: '#FFECEA',
                        fontSize: '14px'
                    }}>
                        <ErrorIcon sx={{marginRight: '5px', fontSize: '18px'}}/>
                        协作者数量已达上限，无法继续邀请
                    </div>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#319F43',
                        padding: '6px',
                        backgroundColor: '#DEFFDE',
                        fontSize: '14px'
                    }}>
                        <CheckCircleIcon sx={{marginRight: '5px', fontSize: '18px'}}/>
                        邀请成功
                    </div>


                    <Box sx={{
                        height: "300px",
                        overflow: "auto"
                    }}>
                        {
                            Array.from({length: 10}, (_, i) => i).map(item => (
                                <Box>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        paddingRight: "3px",
                                        marginTop: '10px'
                                    }}>
                                        <div>
                                            <IconButton
                                                onClick={handleClick}
                                                size="small"
                                                sx={{ml: 2, marginLeft: '10px'}}
                                                aria-controls={open ? 'account-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={open ? 'true' : undefined}
                                            >
                                                <Avatar sx={{
                                                    width: 30,
                                                    height: 30
                                                }}>{localUserInfo?.email.slice(0, 1)}</Avatar>
                                            </IconButton>
                                            <span style={{
                                                color: 'var(--c-text-primary)',
                                                fontSize: '14px',
                                                fontWeight: 500
                                            }}>user1@krene.com</span>
                                        </div>
                                        <Button
                                            onClick={(e) => setCollaboratorAnchorEl(e.currentTarget)}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--c-bg-secondary)'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                            sx={{
                                                backgroundColor: 'transparent',
                                                color: 'var(--c-text-primary)',
                                                fontSize: '14px',
                                                fontWeight: 500,
                                                textTransform: 'none',
                                                minWidth: 'auto',
                                                padding: '4px 8px',
                                                marginLeft: '4px',
                                                '&:hover': {
                                                    backgroundColor: 'var(--c-bg-secondary)'
                                                }
                                            }}
                                            endIcon={<KeyboardArrowDownIcon/>}
                                        >
                                            协作者
                                        </Button>
                                    </div>
                                </Box>
                            ))
                        }
                    </Box>
                    <Menu
                        anchorEl={collaboratorAnchorEl}
                        open={collaboratorOpen}
                        onClose={() => setCollaboratorAnchorEl(null)}
                        slotProps={{
                            paper: {
                                elevation: 0,
                                sx: {
                                    overflow: 'visible',
                                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                    mt: 1.5,
                                    '& .MuiAvatar-root': {
                                        width: 32,
                                        height: 32,
                                        ml: -0.5,
                                        mr: 1,
                                    },
                                    '&::before': {
                                        content: '""',
                                        display: 'block',
                                        position: 'absolute',
                                        top: 0,
                                        right: 14,
                                        width: 10,
                                        height: 10,
                                        bgcolor: 'background.paper',
                                        transform: 'translateY(-50%) rotate(45deg)',
                                        zIndex: 0,
                                    },
                                },
                            },
                        }}
                        transformOrigin={{horizontal: 'right', vertical: 'top'}}
                        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                    >
                        <MenuItem sx={{
                            width: '120px',
                            display: "flex",
                            justifyContent: "space-between"
                        }} onClick={() => setCollaboratorAnchorEl(null)}>
                            协作者
                            <CheckIcon fontSize="small"/>
                        </MenuItem>
                        <Divider/>
                        <MenuItem sx={{
                            width: '120px',
                            display: "flex",
                            justifyContent: "space-between"
                        }} onClick={() => setCollaboratorAnchorEl(null)}>
                            移除
                            <DeleteOutlineIcon fontSize="small" sx={{color: 'red'}}/>
                        </MenuItem>
                    </Menu>*/}

                </Menu>
                {/*<div className='dividing-line' style={{display: onlyReady || !boardId ? 'none' : 'block'}}></div>*/}
                <div className='member-balance' style={{
                    background: currentMember()?.buttonColor
                }} onClick={() => {
                    trackPoint(true)
                    setLabelDialogOpen(true)
                }}>
                    {
                        <div className='lever'
                             style={{color: memberInfo?.membershipTier === 'free' ? 'var(--c-text-primary)' : 'var(--c-on-color)'}}
                        >{memberInfo?.membershipTier?.split('_')[0]}</div>
                    }
                    <div className='balance balance-row'><img className="drop-icon-small"
                                                                            width={12} src={droplet}
                                                                            alt='droplet'/> &nbsp;
                        <div>
                            {(memberInfo?.flowingWater || 0) + (memberInfo?.memberDrops || 0) + (memberInfo?.supplyDrop || 0) + (memberInfo?.otherDrops || 0)}
                        </div>
                    </div>
                </div>
                <Box sx={{display: 'flex', alignItems: 'center', textAlign: 'center'}}>
                    <Tooltip title="Account settings">
                        <IconButton
                            onClick={handleClick}
                            size="small"
                            sx={{ml: 2, marginLeft: '5px'}}
                            aria-controls={open ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                        >
                            <Avatar sx={{width: 30, height: 30}}>{localUserInfo?.email.slice(0, 1)}</Avatar>
                        </IconButton>
                    </Tooltip>
                </Box>
                <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    slotProps={{
                        paper: {
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px var(--c-shadow-mid))',
                                mt: 1.5,
                                '& .MuiAvatar-root': {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                },
                                '&::before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                    zIndex: 0,
                                },
                            },
                        },
                    }}
                    transformOrigin={{horizontal: 'right', vertical: 'top'}}
                    anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                >
                    <div className="user-contact-info">{(function(){
                        const email = localUserInfo?.email || '';
                        const phone = localUserInfo?.phone || '';
                        if (phone) return phone;
                        if (/^1[3-9]\d{9}@/.test(email)) return email.split('@')[0];
                        return email;
                    })()}</div>
                    <div className="menu-header">
                        <div className="uuid-row">
                            <span>ID:</span>
                            <span className="uuid-text">
                                {localUserInfo?.uuid}
                            </span>
                        </div>
                        <Tooltip title={copyUuidTooltipText} open={copyUuidTooltipOpen} arrow placement="top">
                            <IconButton size="small" onClick={copyUuid} sx={{padding: '2px'}}>
                                <ContentCopyIcon sx={{fontSize: 16, color: 'var(--c-text-secondary)'}}/>
                            </IconButton>
                        </Tooltip>
                    </div>
                    <Divider/>
                    <div className="dropShow" onClick={() => {
                        trackPoint(false)
                        setLabelDialogOpen(true)
                    }}>
                        <div>灵感水滴：</div>
                        <img width={16} src={droplet}
                             alt='droplet'/>
                        <div className="drop-show-value">
                            <AnimatedNumber value={(memberInfo?.flowingWater || 0) + (memberInfo?.memberDrops || 0) + (memberInfo?.supplyDrop || 0) + (memberInfo?.otherDrops || 0)} />
                        </div>
                    </div>
                    <MenuItem onClick={() => {
                        trackInvitePopupClick({invite_enter_from: boardId ? 'board' : 'board_management'})
                        setInvitationDialogOpen(true)
                    }}>
                        <ListItemIcon>
                            <GiftBlackIcon/>
                        </ListItemIcon>
                        <span className="menu-item-text">免费水滴</span>
                    </MenuItem>
                    <MenuItem className="changeLang">
                        <ListItemIcon>
                            <LanguageNewIcon/>
                        </ListItemIcon>
                        <span className="menu-item-text">{t('language')}</span>
                        <div className="langBox">
                            <div onClick={() => changeLanguage('zh')}>中文简体</div>
                            <div onClick={() => changeLanguage('en')}>English</div>
                        </div>
                    </MenuItem>
                    {SHOW_THEME_SWITCH && (
                    <MenuItem className="changeLang">
                        <ListItemIcon>
                            <ThemeModeIcon/>
                        </ListItemIcon>
                        <span className="menu-item-text">{t('theme')}</span>
                        <div className="langBox">
                            <div className={mode === 'light' ? 'langBox-active' : ''} onClick={() => changeThemeMode('light')}>亮色</div>
                            <div className={mode === 'dark' ? 'langBox-active' : ''} onClick={() => changeThemeMode('dark')}>暗色</div>
                            <div className={mode === 'system' ? 'langBox-active' : ''} onClick={() => changeThemeMode('system')}>跟随系统</div>
                        </div>
                    </MenuItem>
                    )}
                    <MenuItem onClick={loginOut}>
                        <ListItemIcon>
                            <LeaveIcon/>
                        </ListItemIcon>
                        <span className="menu-item-text">{t('logout')}</span>
                    </MenuItem>
                </Menu>
            </div>
        </React.Fragment>
    );
}
